export const MOCK_SERVICES = [
  {
    id: "photography_8h",
    title_key: "tabifoto.product.photography_8h",
    desc_key: "tabifoto.services.photography_8h.desc",
    features_keys: [
      "tabifoto.services.photography_8h.feature_1",
      "tabifoto.services.photography_8h.feature_2",
      "tabifoto.services.photography_8h.feature_3",
    ],
    image: "https://public.readdy.ai/ai/img_res/08d3886f84783c80883db7a81aa65811.jpg",
    icon: "ri-camera-line",
  },
  {
    id: "photography_video",
    title_key: "tabifoto.product.photography_video",
    desc_key: "tabifoto.services.photography_video.desc",
    features_keys: [
      "tabifoto.services.photography_video.feature_1",
      "tabifoto.services.photography_video.feature_2",
      "tabifoto.services.photography_video.feature_3",
    ],
    image: "https://readdy.ai/api/search-image?query=cinematographer%20filming%20couple%20in%20Japan%20beautiful%20soft%20light%20cinematic%20style%20film%20aesthetic%20moody%20emotional%20storytelling%20camera%20equipment%20Japanese%20garden%20sakura&width=400&height=320&seq=service-photo-video&orientation=landscape",
    icon: "ri-video-line",
  },
];

export const MOCK_ADDONS = [
  {
    id: "kimono",
    title_key: "tabifoto.booking.kimono_title",
    desc_key: "tabifoto.booking.kimono_desc",
    icon: "ri-shirt-line",
    image: "https://readdy.ai/api/search-image?query=woman%20wearing%20traditional%20Japanese%20kimono%20in%20Kyoto%20beautiful%20soft%20light%20pastel%20colors%20peaceful%20serene%20temple%20garden%20low%20saturation%20film%20grain&width=120&height=120&seq=addon-kimono&orientation=squarish",
  },
  {
    id: "makeup",
    title_key: "tabifoto.booking.makeup_title",
    desc_key: "tabifoto.booking.makeup_desc",
    icon: "ri-brush-line",
    image: "https://readdy.ai/api/search-image?query=Japanese%20makeup%20artist%20professional%20beauty%20styling%20studio%20soft%20natural%20light%20elegant%20minimal%20aesthetic%20clean%20beauty%20photography&width=120&height=120&seq=addon-makeup&orientation=squarish",
  },
];
